import { FormikHelpers } from "formik";
import { TFunction } from "i18next";
import { ShipmentCommentFormValues } from "types/OutgoingForms/ShipmentComment";
import { toastResponseError } from "utils/responseMessageHelper";
import * as yup from "yup";

export const shipmentCommentFormik = (
  t: TFunction,
  shipment: any,
  updateComment: (id: string, data: { customer_comment: any }) => Promise<any>,
) => ({
  validateOnChange: false,
  validateOnBlur: false,
  enableReinitialize: false,
  initialValues: {
    comment: shipment.get("customer_comment", "") || "",
  },
  validationSchema: () =>
    yup.object().shape({
      comment: yup
        .string()
        .trim()
        .max(50, t("error.stringShorter", { length: 50 })),
    }),
  onSubmit: (
    values: ShipmentCommentFormValues,
    { setSubmitting }: FormikHelpers<ShipmentCommentFormValues>,
  ) => {
    const id = shipment.get("id");
    const data = {
      customer_comment: values.comment,
    };
    updateComment(id, data)
      .catch(toastResponseError)
      .finally(() => setSubmitting(false));
  },
});
